import Widget from 'widgets/Widget'

export default class SmartviewContentSeparator extends Widget {
  renderWidget () {
    return (
      <div className='smartview-content-separator border-t border-gray-200 my-8' />
    )
  }
}
